import { useQuery } from '@apollo/client';
import {
  ApacCandidateFooter,
  ApacCandidateHeader,
} from '@seek/apac-candidate-header-footer';
import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';
import { Divider, Page } from 'braid-design-system';
import { useLocation } from 'react-router';

import { GetCandidateDetailsDocument } from 'src/generated/graphql';

import { ContentPage } from './ContentPage';
import { PreviewBranchName } from './components/PreviewBranchName';
import { useAppConfig } from './providers/AppConfigProvider';
import { useLanguageSwitcher } from './services/header/useLanguageSwitcher';

export const MainLayout = () => {
  const { isAuthenticated, client } = useAppConfig();
  const { pathname, search } = useLocation();

  const { languageSwitcher, onLanguageSwitch } = useLanguageSwitcher();

  const authenticationStatus = isAuthenticated
    ? AUTHENTICATION_TYPES.AUTHENTICATED
    : AUTHENTICATION_TYPES.UNAUTHENTICATED;

  const isBrowser = client === 'browser';

  const { data } = useQuery(GetCandidateDetailsDocument, {
    skip: !isAuthenticated,
  });

  const userProfile = isAuthenticated
    ? {
        firstName: data?.viewer?.personalDetails.firstName ?? '',
        lastName: '',
        email: data?.viewer?.emailAddress,
        profilePhotoUrl: data?.viewer?.profileAvatar?.image128Url ?? undefined,
      }
    : undefined;

  return (
    <Page
      footer={
        isBrowser ? (
          <>
            <Divider />
            <br />
            <ApacCandidateFooter authenticationStatus={authenticationStatus} />
          </>
        ) : null
      }
    >
      <PreviewBranchName />
      {isBrowser ? (
        <ApacCandidateHeader
          returnUrlForPostAuth={`${pathname}${search}`}
          authenticationStatus={authenticationStatus}
          userProfile={userProfile}
          activePrimaryTab="peopleSearch"
          languageSwitcher={languageSwitcher}
          onLanguageSwitch={onLanguageSwitch}
        />
      ) : null}
      <ContentPage />
    </Page>
  );
};
